import { EMPTY_ARRAY } from '@e-socna/empty';

const ROLE_REQUIREMENT_LABELS_FR: Record<string, string> = {
  dispatchAction: "Déclencher l'action",
  read: 'Lire',
  readAmounts: 'Lire les montants',
  readCosts: 'Lire les coûts',
};

export interface RoleRequirementEntry {
  readonly key: string;
  readonly label: string;
  readonly value: object;
}

export const extractRoleRequirements = (
  raw: unknown,
): readonly RoleRequirementEntry[] => {
  if (typeof raw !== 'object' || raw === null) {
    return EMPTY_ARRAY;
  }

  const { roleRequirements } = raw as Record<string, unknown>;

  if (typeof roleRequirements !== 'object' || roleRequirements === null) {
    return EMPTY_ARRAY;
  }

  return Object.entries(roleRequirements)
    .filter(
      ([key, value]) =>
        key !== '_id' && typeof value === 'object' && value !== null,
    )
    .map(([key, value]) => ({
      key,
      label: ROLE_REQUIREMENT_LABELS_FR[key] ?? key,
      value: value as object,
    }));
};
